import 'regenerator-runtime/runtime';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './config/firebasedeconfig';  // Importez votre configuration Firebase ici
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./styles/index.scss";
import 'bootstrap/dist/css/bootstrap.min.css';
import { initializeSentry } from './sentryConfig';
import 'react-toastify/dist/ReactToastify.css';
import 'react-quill/dist/quill.snow.css';
import { HelmetProvider } from 'react-helmet-async';

initializeSentry();

const container = document.getElementById('root');
const root = createRoot(container); // Créez une racine

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();

// PWA: register our Service Worker (push notifications + installability)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      console.warn('[PWA] Service Worker registration failed:', error);
    });
  });
}


